import React from "react";
import Footer from "./../Footer";
import { Link, withRouter } from "react-router-dom";

import { Pages, Settings } from "./Pages";

class Chapter8 extends React.Component {
  constructor(props) {
    super(props);

    this.page = Pages[9];
    this.handleTogglePopout = this.handleTogglePopout.bind(this);
  }

  handleTogglePopout = popout => {
    this.props.togglePopout(popout);
  };

  componentDidMount() {
    this.props.bgHoverState(this.page.color);
    this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

    document.title = `${this.page.name.replace(
      /<br \/>/g,
      ""
    )} | Peapack 100 Anniversary`;
    document.body.className = "page-inner page-chapter-6";
  }

  render() {
    return (
      <div className="page-wrapper">
        <div className="page">
          <div className="header-section wrapper">
            <div className="row">
              <div className="col-left col-md-6">
                <div className="header-content">
                  <Link
                    to="/"
                    onClick={this.props.bgHoverState}
                    className="back-button"
                  >
                    Back
                  </Link>
                  <h1>
                    Leader for <br />
                    All Generations: <br />
                    T. Leonard Hill
                  </h1>
                  <div className="caption">
                    T. Leonard Hill (courtesy of Garner Hill II){" "}
                  </div>
                </div>
              </div>
              <div className="col-right col-md-6">
                <figure className="header-thumbnail anim-up">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/leonard-hill.jpg`}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="white-background entry-content">
            <div className="wrapper">
              <div className="row">
                <div className="col-md-8">
                  <p>
                    T. Leonard Hill was perhaps the most influential leader in
                    the Bank’s first 100 years. Always known as Leonard to
                    friends and family, he was a community leader and
                    businessman. The son of Bank co-founder G. F. Hill, Mr. Hill
                    was affiliated with the Bank throughout his long life,
                    serving as a Judge of Elections, Bank Director, Chairman of
                    the Board, and Chairman Emeritus.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <p>
                    In a 2003 interview, Mr. Hill recalled the construction in
                    1921 of the Bank’s original location at 219 Main Street,
                    straddling the villages of Peapack and Gladstone. The
                    ten-year-old boy witnessed the digging of the cellar, the
                    pouring and hand-mixing of cement, and the completion of the
                    duplex building that would house the Bank and his father’s
                    hardware store. Soon after, his first Bank duties included
                    emptying waste baskets and performing basic janitorial
                    duties.
                  </p>
                </div>
                <div className="col-md-4">
                  <figure className="img abs-md">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/hill-and-kissel.jpg`}
                      alt=""
                    />
                    <figcaption>
                      Mr. Hill and Mr. Kissel at the Bank’s seventy-fifth annual
                      meeting, April 23, 1996 (Peapack-Gladstone Bank archives)
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <p>
                    After graduating from Bernards High School, Mr. Hill
                    obtained his college degree at Rider College in 1933. Except
                    for his college years, Mr. Hill lived his entire life in the
                    Gladstone area. Mr. Hill and his wife of sixty-one years,
                    Judy Sjostrom Hill, were parents of a son and a daughter:
                    Garner “Buzz” Hill II and Pamela Hill. Pam Hill would become
                    a member of the Bank’s Board of Directors in 1991.
                  </p>
                  <p>
                    Like his father, Mr. Hill was a community-minded individual;
                    he fondly recalled fighting fires and driving the town’s
                    fire truck at age fifteen. He became an official member of
                    the Peapack-Gladstone Fire Department in 1933 and served for
                    seventy-three years, ultimately as Treasurer, then Chief.
                    Mr. Hill also served the community as an elected member of
                    the Peapack-Gladstone Borough Council and the First Captain
                    of the Peapack-Gladstone First Aid Squad.
                  </p>
                  <p>
                    Mr. Hill started his professional life by working for his
                    father’s lumber and hardware company. By 1936, as the local
                    economy was showing early signs of improvement from the
                    Great Depression, Mr. Hill launched his first business
                    venture with the opening of Hill Chevrolet in Gladstone.
                    Between making deliveries to farms and estates throughout
                    The Somerset Hills while working for his father and selling
                    cars at Hill Chevrolet, Mr. Hill became widely known and
                    universally respected. He was also the president of the
                    Ferris Corporation, his family’s realty company, which
                    acquired and managed numerous commercial and residential
                    rental properties in Peapack-Gladstone. Mr. Hill’s first
                    official Bank-related position was performing the role of
                    Judge of Elections at the Bank’s annual shareholder meeting
                    in 1935. In 1944, Francis K. Stevens asked Mr. Hill to join
                    the Board of Directors, cementing his full involvement with
                    the Bank for the remainder of his life. According to his
                    daughter, Pam, “the Bank was his baby.”
                  </p>
                  <p>
                    When the Bank marketed additional shares to fund its new
                    building in 1957, Mr. Hill was instrumental in raising the
                    necessary capital by investing his personal funds and
                    soliciting prospective shareholders throughout the
                    community. His belief in the Bank was so strong that he
                    convinced construction workers employed at the building site
                    to buy stock as an investment in their future. Mr. Hill took
                    pride in the building’s elegant architectural design and
                    neighborly appearance. He believed that the Bank’s
                    environment should reflect “high class in a soft way.”
                  </p>
                  <figure className="img">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/grand-marshall.jpg`}
                      alt=""
                    />
                    <figcaption>
                      Mr. Hill as Grand Marshal of the Peapack-Gladstone Fire
                      Department’s 100th anniversary parade in 2005
                      (Peapack-Gladstone Bank archives){" "}
                    </figcaption>
                  </figure>
                  <p>
                    Over the next thirty years, Mr. Hill deftly combined his
                    business, community, and family responsibilities with his
                    passion for the Bank. On July 13, 1989, Mr. Hill succeeded
                    George Jenkins as the Bank’s Chairman of the Board, the
                    second member of his family to hold the position. As both a
                    Director and Chairman of the Board, Mr. Hill served the Bank
                    with a steadfast commitment and limitless enthusiasm. He was
                    a hands-on Chairman, involved with Bank initiatives every
                    step of the way. As the Bank’s growth accelerated in the
                    1980s and 1990s, technology was becoming a critical new
                    focal point. Mr. Hill’s lifelong reputation for embracing
                    change led him to spur the Bank toward increasingly
                    expensive technology investments. He understood that the
                    computerization of the Bank’s operations was the only way
                    the Bank could grow with its customers.
                  </p>
                  <p>
                    One of Mr. Hill’s most cherished Bank projects was the
                    Chairman’s Club, introduced in July 1998. The Club was
                    established to provide, in Mr. Hill’s words, “special
                    banking services for our friends sixty years of age and
                    better.” Members were invited to participate in
                    Bank-sponsored programs and trips—both entertaining and
                    educational. Mr. Hill’s Chairman’s Club was an immediate
                    success. Within months of unveiling the concept, he said,
                    “The response we have received thus far has been tremendous.
                    We currently have over 500 members and the number continues
                    to grow.”
                  </p>
                  <p>
                    Mr. Hill served as Chairman of the Board from 1989 to 2002.
                    Upon his retirement as Chairman, he was named Chairman
                    Emeritus by the Board of Directors. President Frank A.
                    Kissel stated,
                  </p>
                  <blockquote className="mt-5">
                    Mr. Hill’s years of banking experience and in-depth
                    knowledge of our growing communities are an asset to
                    Peapack-Gladstone Bank. . . . Under Mr. Hill’s direction and
                    with the assistance of our other Board members, our
                    management group and Bank staff will continue to meet the
                    financial needs of our community while providing excellent
                    results to our shareholders. Mr. Hill represents the second
                    generation Chairman at our Bank, and his family has provided
                    leadership to the Bank since its inception in 1921.
                  </blockquote>
                  <p>
                    Mr. Hill passed away on March 30, 2006. Throughout his
                    ninety-four years, he was known for his fairness,
                    compassion, and the desire to treat all customers alike—no
                    matter the size of their assets. Mr. Hill instructed
                    employees to “treat the little guy the same as the big guy.”
                    His positive attitude in the face of any challenge, his
                    humble demeanor, and his clear-thinking common sense bonded
                    and motivated several generations of Bank employees.
                  </p>
                  <p>
                    Mr. Hill is remembered for distributing the following “Ten
                    Business Commandments” to Bank employees; they reflect his
                    pragmatic thinking and his desire to share heartfelt advice.
                    The actions they espouse reflect Mr. Hill’s personality and
                    continue to guide the Bank’s culture and ethics.
                  </p>
                  <h5 className="title mt-5">
                    “The Ten Business Commandments”
                  </h5>
                  <ol className="bold-title">
                    <li>
                      <strong>Work Hard.</strong> Take the hardest job first
                      every day.
                    </li>
                    <li>
                      <strong>Study Hard.</strong> The more you know, the easier
                      and more efficient is your work.
                    </li>
                    <li>
                      <strong>Have Initiative.</strong> Ruts often deepen into
                      graves.
                    </li>
                    <li>
                      <strong>Love Your Work.</strong> There is a sense of
                      satisfaction in doing work well.
                    </li>
                    <li>
                      <strong>Be Exact.</strong> Accuracy is better than haste.
                    </li>
                    <li>
                      <strong>Have Courage.</strong> A stout heart will carry
                      you through difficult times.
                    </li>
                    <li>
                      <strong>Be Friendly.</strong> Only friendly people become
                      successful leaders.
                    </li>
                    <li>
                      <strong>Cultivate Personality.</strong> Personality is to
                      man what perfume is to the flower.
                    </li>
                    <li>
                      <strong>Wear a Smile.</strong> It opens the door into the
                      sunshine and beyond.
                    </li>
                    <li>
                      <strong>Do Your Best.</strong> For if you give the world
                      your best, the best will come back to you.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <Footer togglePopout={this.handleTogglePopout} />
        </div>
      </div>
    );
  }
}

export default withRouter(Chapter8);
